import React, {
    ReactNode,
} from 'react'
import {
    openChatwoot,
} from '@src/services/chatwoot'
import ErrorWithSupport from './components/ErrorWithSupport'

type Props = {
    message?: string | ReactNode
    onBackClick: () => void
    header?: string | ReactNode
}

function ErrorWithSupportPage({
    message, onBackClick, header,
}: Readonly <Props>): JSX.Element {
    return (
        <ErrorWithSupport
            onBackClick={onBackClick}
            onSupportClick={openChatwoot}
            message={message}
            header={header}
        />
    )
}

export default ErrorWithSupportPage
